import type { ID } from '@octopus-do/octopus-project-core'
import { ButtonTile } from '@octopus-do/octopus-storybook'
import {
  FileImportLight,
  PlusLight,
  SparklesLight,
  WavePulseLight,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { useSelector } from 'react-redux'

import { selectIsLoading } from '@/store'
import { useProjectActions } from './hooks'
import css from './styles.module.css'

interface Props {
  workspaceId: ID
}

export const NewProjectButtons: React.FC<Props> = ({ workspaceId }) => {
  const loading = useSelector(
    selectIsLoading('project_save', 'project_create', 'validate_projects_count')
  )

  const { onImport, onCreate, onGenerate, onReport } = useProjectActions(
    workspaceId,
    loading
  )

  return (
    <div className={css.new_project_buttons}>
      <ButtonTile
        loading={loading}
        title="New project"
        type="primary"
        icon={PlusLight}
        onClick={onCreate}
      />
      <div className={css.generate_button}>
        <ButtonTile
          title="Generate with AI"
          type="secondary"
          icon={SparklesLight}
          onClick={onGenerate}
        />
      </div>
      <ButtonTile
        title="Import website"
        type="secondary"
        icon={FileImportLight}
        onClick={onImport}
      />
      <ButtonTile
        title="Sitemap audit"
        type="secondary"
        icon={WavePulseLight}
        onClick={onReport}
      />
    </div>
  )
}
